import * as React from 'react';
import { render } from 'react-dom';
import Horseshoe, { Props } from './horseshoe';

export function renderHorseshoe(
    id: string,
    props: Props,
    callback?: () => void,
) {
    if (document) {
        const container = document.getElementById(id);
        if (container) {
            render(<Horseshoe {...props} />, container, callback);
        }
    }
}
